import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: 'yp4dfrwh',
  dataset: 'production',
  useCdn: false,
  apiVersion: '2026-05-05',
});
